import React from 'react'
import AppRouter from "./routes/index";
import 'semantic-ui-css/semantic.min.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import configureStore from './store/';

import './styles/index.css';
import './styles/index.scss';
import './styles/menu.css'
import './styles/menu.scss'

const store = configureStore();

const clientID = process.env.REACT_APP_GOOGLE_CLIENT_ID

function App() {

  return (

    <Provider store={store}>
      <GoogleOAuthProvider clientId={clientID} language="en">
        <AppRouter />
      </GoogleOAuthProvider>
    </Provider>
  );
}

export default App;
